import {
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Typography,
} from '@mui/material';
import { Grid } from '@mui/material';
import Heading from 'components/Heading';
import { ApiResponses } from 'lib/trpcClient';

type Props = {
  issues: ApiResponses['interestPayment']['processUpload']['errors'];
  tableContentsType: 'warnings' | 'errors';
};

const IssueFeedbackTable: React.FC<Props> = ({ issues, tableContentsType }) => {
  const heading =
    tableContentsType === 'errors' ? 'Upload error...' : 'Upload warnings...';
  const note =
    tableContentsType === 'errors'
      ? 'The following rows contain errors. Please correct them and try again:'
      : 'The following rows contain warnings:';
  return (
    <Grid size={{ md: 12 }} className="mt-8">
      <Heading variant="h2">{heading}</Heading>
      <Typography color="textDarkBodyText">{note}</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <em>Row number</em>
            </TableCell>
            <TableCell>
              <em>
                {tableContentsType === 'errors' ? 'Error' : 'Warning'}{' '}
                description
              </em>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {issues.map((issue, index) => {
            return (
              <TableRow key={`${issue.lineNo}-${index}`}>
                <TableCell>{issue.lineNo}</TableCell>
                <TableCell>{issue.message}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default IssueFeedbackTable;
